import { defineStore } from 'pinia'
import { ref } from 'vue'
import { IDspMinimalCpm } from '@/apps/traforama/interfaces/dspMinimalCpms'
import { fetchItems } from '@/apps/traforama/api/dspMinimalCpms'

export const useDspMinimalCpmsStore = defineStore('dspMinimalCpms', () => {
  const items = ref<{ [itemId: string]: IDspMinimalCpm }>({})

  const FetchItems = async (typeId: number) => {
    const response = await fetchItems(typeId)
    response.data.forEach((item: IDspMinimalCpm) => {
      if (item.id !== undefined) {
        items.value[item.attributes.country_id] = item
      }
    })
  }

  return {
    items,
    FetchItems
  }
})
